(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DarkCore", [], factory);
	else if(typeof exports === 'object')
		exports["DarkCore"] = factory();
	else
		root["DarkCore"] = factory();
})(self, () => {
return 